import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Column,Panel} from 'ktm-ui';

interface IdsExpenseType {
    Id:string;
    Policy_Id:string;
    ShortName:string;
};

export default KTMScreen({name:"enroll.ben-limit.remove-expense-type"}, class extends React.Component<{policy_id:string,expense_id:string}> {

    data:{
        dsExpenseType:IdsExpenseType;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsExpenseType";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
            "@expense_id":this.props.expense_id,
        });
        screen.title = "Remove expense type";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Remove expense type"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Remove" style="destructive"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    <Display field={field("ShortName")}/>
                </Column>
            </Panel>
        );
    }

    async submit({screen}:ActionEvent){
        await KTMApi.action(screen,"submit",{
            "@expense_id":this.props.expense_id,
            "@policy_id":this.props.policy_id,
        });
        screen.recordChanged("updated",this.props.expense_id);
        screen.close({"continue":true});
    }

});
